import type { GeneratedAssetTool } from '@pulsify/shared/dto'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { assetLibraryApi } from '../api/generated-asset-api'

export function useGeneratedAssets(businessId: string, tool?: GeneratedAssetTool) {
  return useQuery({
    queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId, tool ?? 'all'),
    queryFn: () => assetLibraryApi.list(businessId, tool),
    enabled: !!businessId,
    staleTime: 30_000,
  })
}

export function useDeleteGeneratedAsset(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (assetId: string) => assetLibraryApi.remove(businessId, assetId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId),
      })
    },
  })
}
